import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

const SkipAPayInfo = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Skip a Pay | MAX Credit Union';
  }, []);

  useEffect(() => {
    // Add any necessary validation or data fetching here
  }, [navigate]);


  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {isCollapsed && <TopMenu />}
      <div style={{ display: 'flex', flex: 1 }}>
        <SideMenu menuItems={menuItems} />
        
        <div style={{ flex: 1, padding: '20px 20px 20px 260px', overflow: 'auto' }}>
          <style type="text/css">
            {`
              .btnwrapper {padding: 20px;}
              .ctr {text-align: center;}
              q2-btn {width: 40%;}
              body {}
              p {font-size: medium; font-weight: normal;}
              h1, h2, h3, h4, h5, h6 {font-size: large; font-weight: bold; color: #3b8ede;}

              .select-container {
                  display: flex;
                  gap: 10px;
              }

              .custom-select {
                  width: 50%;
              }

              img {
                  max-width: 100%;
                  height: auto;
                  display: block;
                  margin: 0 auto;
              }

              @media screen and (max-width: 768px) {
                div[style*="padding: 20px 20px 20px 260px"] {
                  padding: 20px 20px 20px 60px !important;
                }
              }
            `}
          </style>
          <img src="/SkipAPayHeaders-Loading.png" alt="Banner Image" />

          <div>
            <h3><br />Your loan does not qualify for online Skip A Pay at this time. If you have any questions, please contact us at 1.800.776.6776.</h3>
            <p>Reasons your loan may not qualify:</p>
            <ul>
              <li>You have skipped a payment within the past 12 months.</li>
              <li>This is a joint loan. Currently only single loans qualify for online Skip A Pay.</li>
              <li>Your loan has been open for less than 6 months.</li>
            </ul>
            <p>&nbsp;</p>
            <h3>What is Skip A Pay?</h3>
            <p>Take a month off from your loan payment. That's right! With Skip A Pay, you can skip your next monthly payment on any qualifying MAX loan and keep the cash.</p>
            <p>How it Works:</p>
            <ul>
              <li>Skip one monthly payment on a qualifying MAX loan once per year.</li>
              <li>Complete the form and pay a $35 fee to schedule your skip.</li>
              <li>Use the extra cash for bills, emergency expenses, holiday shopping, vacations, or any financial need.</li>
            </ul>
            <p>The Skip A Pay program gives you the option to defer monthly payments on an eligible MAX Loan. The skipped payments are added to the end of the loan without affecting your credit.</p>
          </div>


        </div>
      </div>
    </div>
  );
};

export default SkipAPayInfo;